<div [ngClass]="{ online: online(), offline: !online() }" class="card border-0" data-bs-theme="light">
  <ng-content select="[card-image]" />
  <div class="card-overlay">
    <div class="spacer"></div>
    <div class="cutout">
      <h2 class="card-title">{{ title() }}</h2>
    </div>
    <div class="spacer"></div>
    <nav class="card-nav">
      @if (navItems().length > 0) {
        <ul>
          @for (item of navItems(); track $index) {
            <li>
              <a
                [href]="item.href"
                [attr.aria-label]="item.tooltip"
                [ngbTooltip]="item.tooltip"
                target="_blank"
                rel="noopener"
                placement="auto"
                container="body"
                [openDelay]="300">
                <app-icon height="1.25em" [icon]="item.icon" />
              </a>
            </li>
          }
        </ul>
      }
    </nav>
  </div>

  <div class="card-body">
    <ng-content />
  </div>

  <div class="card-footer">
    <ng-content select="[card-footer]" />
  </div>
</div>
